<template>
  <a-empty style="width:100%;height:100%" :description="tips" />
</template>

<script>
export default {
  props: {
    tips: {
      type: String,
      default: () => '无相关信息匹配'
    }
  },
  data() {
    return {

    }
  },
  components: {

  }
}
</script>
